import { shallowRef, ref, computed } from 'vue'
import { useTemplate } from '../../../hooks/index'
import { setValueByPathToVue } from '../../../utils/index'

export function useCriteriaGroups() {
  const { getTemplateData, compileData } = useTemplate()
  const groupsForm = shallowRef(null)
  const groups = ref({})
  const onlyShowFieldsByKey = {}
  const onlyShowFields = computed(() => {
    const fields = []
    const keys = Object.keys(groups.value)
    for (const key of keys) {
      if (groups.value[key] === true) {
        fields.push(...onlyShowFieldsByKey[key])
      }
    }
    return [...new Set(fields)]
  })
  const setGroupsForm = (resData, searchData) => {
    const templateData = getTemplateData()
    //增加查询事件（当值改变时触发查询）
    const query = (val, property) => {
      setValueByPathToVue(groups.value, property, val)
      searchData()
    }
    groupsForm.value = {
      code: resData.criteria?.code,
      id: resData.criteria?.id,
      form: {
        property: {
          formGroup: false,
        },
      },
      items: resData.groups.map((im) => {
        if (!im.parameter) im.parameter = {} //初始化parameter
        if (!im.component?.code) {
          im.component = { code: 'PgCheckbox' }
        }
        if (im.component?.code === 'PgCheckbox') {
          im.parameter.text = im.label
          im.label = ''
        }
        if (im.chosen) {
          setValueByPathToVue(groups.value, im.property, true)
        }
        if (im.defaultValue) {
          setValueByPathToVue(groups.value, im.property, compileData(im.defaultValue, templateData))
        }
        if (im.parameter.onlyShowFields) {
          onlyShowFieldsByKey[im.property] = im.parameter.onlyShowFields
          delete im.parameter.onlyShowFields
        }
        //增加查询事件（当值改变时触发查询）
        im.parameter.event = {
          change: (val) => query(val, im.property),
          'on-change': (val) => query(val, im.property),
        }
        return im
      }),
    }
  }

  return {
    groupsForm,
    groups,
    onlyShowFields,
    setGroupsForm,
  }
}
